// 消息通知 - ID
export const NOTICE_ID = 'idt_notice_id'
// 消息通知 - STATUS
export const NOTICE_STATUS = 'idt_notice_status'

export const A_MAP_KEY = 'ccd6e85467f5024e9bb9ba43b5888ae2'
export const A_MAP_CODE = '3189825b56263f0efc090efe339f6793'